import { gql } from '@apollo/client/core';

export const MODULE_REGISTRATION_PAYMENTS = gql`
  query ModuleRegistrationPayments($module_ids: [ID!]!) {
    moduleRegistrationPayments(module_ids: $module_ids) {
      amount paid outstanding cleared
      modules { module_id module_name bill_id amount paid outstanding cleared attempt_number }
    }
  }
`;
